import { API_BASE_URL } from "@kupikupi/brand";
import { useQuery } from "@tanstack/react-query";
import { getUserStatistics } from "../endpoints/user";
import type { UserStatistics } from "../types/user";

/**
 * `GET /user/statistics` (StatisticsVo) — per-user dashboard counts. The
 * warehouse page reads `warehouseQuantity` for the "在仓商品" KPI. Auth required;
 * a null token disables the query.
 */
export function useUserStatistics(authToken: string | null) {
  return useQuery<UserStatistics>({
    queryKey: ["user", "statistics"],
    enabled: !!authToken,
    queryFn: () => {
      if (!authToken) throw new Error("NO_TOKEN");
      return getUserStatistics({ baseUrl: API_BASE_URL }, authToken);
    },
    staleTime: 60_000,
  });
}
